export class SearchContentRequest {
    q: string;
    contentTypes?: string;
    convoTypes?: string;
    requireChannel?: boolean;
}
